<template>
  <div class="container">
    <div class="row paper-container">
      <div
        class="col paper-part__header"
        :style="{ backgroundColor: this.getConfig(title).backgroundColor }"
      >
        <div class="paper-part__icon">
          <img :src="this.getConfig(title).icon" />
        </div>
        {{ this.getConfig(title).name }}
      </div>
      <div class="col paper-part" v-for="range in ranges" :key="range.label">
        <div class="paper-part__title">
          {{ getLabels(range.label).name }}
        </div>
        <div class="paper-part__amount">
          {{ range.amount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cross from "../../../assets/images/cross.svg";
import Home from "../../../assets/images/house.svg";
import Like from "../../../assets/images/like.svg";
import QMark from "../../../assets/images/question-mark.svg";

export default {
  name: "Paper",
  props: ["title", "ranges"],
  data() {
    return {
      labels: [
        { key: "age_0_10_range", name: "0 - 10 anos" },
        { key: "age_11_20_range", name: "11 - 20 anos" },
        { key: "age_21_50_range", name: "21 - 50 anos" },
        { key: "age_51_60_range", name: "51 - 60 anos" },
        { key: "age_61_or_higher_range", name: "61 anos ou +" }
      ]
    };
  },
  methods: {
    getConfig(title) {
      const config = [
        {
          status: "no_restriction",
          name: "S/ restrições",
          icon: Like,
          backgroundColor: "#28a745"
        },
        {
          status: "social_isolation",
          name: "Isolamento social",
          icon: Home,
          backgroundColor: "#ffc107"
        },
        {
          status: "suspected_of_contamination",
          name: "Suspeita de contaminação",
          icon: QMark,
          backgroundColor: "#fd7e14"
        },
        {
          status: "death",
          name: "Óbito",
          icon: Cross,
          backgroundColor: "#dc3545"
        }
      ];
      return config.find(item => item.status === title);
    },

    getLabels(label) {
      return this.labels.find(item => item.key === label);
    }
  }
};
</script>

<style lang="css" scoped>
.paper-container {
  border: 1px solid #888;
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25em;
  margin: 0.33em;
  text-align: center;
}

.paper-part {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-right: 1px solid #888;
}

.paper-part:last-of-type {
  border-right: none;
}

.paper-part__header {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.1em;
}

.paper-part__icon {
  height: 40%;
}

.paper-part__title {
  border-bottom: 1px solid #888;
  width: 100%;
  padding-top: 1em;
  padding-bottom: 0.5em;
  font-weight: bold;
}

.paper-part__amount {
  padding: 2em;
  font-size: 1.4em;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>